export const iosimStatusMock = {
  status: 'before-load',
  progress: 0,
};
